import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Link2 } from "lucide-react";

// Sprint SLUG-VEICOLI — rigenerazione slug di QUESTA azienda: anteprima completa, poi conferma.
export default function RigeneraSlugPanel({ companyId }) {
  const [esito, setEsito] = useState(null);
  const [busy, setBusy] = useState(false);

  const chiama = async (conferma) => {
    setBusy(true);
    try {
      const r = await api.post(`/companies/${companyId}/public-api/rigenera-slug`, { conferma });
      setEsito(r.data);
      if (conferma) toast.success(`Slug rigenerati: ${r.data.cambiati} cambiati, ${r.data.invariati} invariati`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore rigenerazione slug");
    } finally { setBusy(false); }
  };

  return (
    <div className="mt-6 pt-5 border-t border-slate-100" data-testid="rigenera-slug-panel">
      <div className="flex items-center gap-2 mb-1">
        <Link2 className="h-4 w-4 text-slate-500" />
        <h4 className="font-medium text-sm text-slate-800">Indirizzi dei veicoli (slug)</h4>
      </div>
      <p className="text-xs text-slate-400 mb-3">
        Solo i veicoli di questa azienda che hanno già un indirizzo, cestinati compresi. Il vecchio indirizzo continua a funzionare e reindirizza al nuovo.
      </p>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" disabled={busy} onClick={() => chiama(false)} data-testid="rigenera-slug-anteprima-btn">Anteprima</Button>
        {esito?.anteprima && esito.cambiati > 0 && (
          <Button size="sm" disabled={busy} onClick={() => chiama(true)} className="bg-amber-600 hover:bg-amber-700" data-testid="rigenera-slug-conferma-btn">
            Conferma e rigenera {esito.cambiati}
          </Button>
        )}
      </div>
      {esito && <EsitoSlug esito={esito} />}
    </div>
  );
}

function EsitoSlug({ esito }) {
  return (
    <div className="mt-3" data-testid="rigenera-slug-esito">
      <div className="text-sm text-slate-700 mb-2" data-testid="rigenera-slug-conteggio">
        {esito.anteprima ? "Anteprima" : "Eseguito"}: {esito.totale} veicoli · {esito.cambiati} cambiano · {esito.invariati} invariati
      </div>
      <div className="max-h-80 overflow-auto border border-slate-100 rounded">
        <table className="w-full text-xs">
          <thead className="bg-slate-50 text-slate-500 sticky top-0">
            <tr><th className="text-left p-2">Codice</th><th className="text-left p-2">Slug attuale</th><th className="text-left p-2">Slug nuovo</th><th className="text-left p-2">Stato</th></tr>
          </thead>
          <tbody>
            {esito.veicoli.map((r) => (
              <tr key={r.vehicle_id} className="border-t border-slate-100 align-top" data-testid={`rigenera-slug-riga-${r.vehicle_id}`}>
                <td className="p-2 whitespace-nowrap">{r.codice}{r.cestinato && <span className="text-slate-400"> (cestino)</span>}</td>
                <td className="p-2 font-mono break-all text-slate-500">{r.slug_vecchio}</td>
                <td className="p-2 font-mono break-all">{r.slug_nuovo} <span className="text-slate-400">({r.lunghezza})</span></td>
                <td className={`p-2 ${r.stato === "cambia" ? "text-amber-700" : "text-slate-400"}`}>{r.stato}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
